<div class="loading" *ngIf="!loaded"></div>
<main *ngIf="loaded">
    <div class="app app-margin" [dir]="textDir">
        <div class="app-container-pm">
            <section class="nav-area">
                <div class="row top-section padT15">
                    <div class="column md-5 lg-5 xl-5">
                        <section class="breadcrmb labeltxt">
                            <a [routerLink]="['/']" class="breadcrum">{{'Home' | translate}}</a> /
                            <ng-container *ngIf="loggedInUser?.role?.name==='GeneralAdmin' || loggedInUser?.role?.name==='ProjectAdmin'">
                            <a [routerLink]="['/projectmanagement']" class="breadcrum" *ngIf="loggedInUser?.role?.name==='GeneralAdmin' || loggedInUser?.role?.name==='ProjectAdmin'">{{'Project management' | translate}}</a> /
                            <a [routerLink]="['/projectmanagement',this.project_id, 'view']" class="breadcrum" *ngIf="loggedInUser?.role?.name==='GeneralAdmin' || loggedInUser?.role?.name==='ProjectAdmin'">{{this.projectData?.name}}</a> /
                                <a [routerLink]="['/projectmanagement',this.project_id, this.school_id,'view']" class="breadcrum">{{'School Management' | translate}}</a> /
                            </ng-container>
                            <ng-container *ngIf="loggedInUser?.role?.name=='SchoolAdmin'">
                                <a [routerLink]="['/schoolmanagement']" class="breadcrum">{{'School Management' | translate}}</a> /
                            </ng-container>
                                <span class="active">{{'School set-up' | translate}}</span>
                        </section>
                        <div class="lg-6 marT5">
                            <label class="title-18">{{'School set-up' | translate}}</label>
                        </div>
                    </div>
                    <div class="marL15">
                        <div class="card successbox" *ngIf="stepMessage">
                            <div class="header vertical-center">
                              <div class="left flexStart">
                               
                                     <div><i class="icon icon-check"></i></div>
                               
                                    
                                    <div class="font14 padT2" [ngClass]="textDir=='ltr'?'marL10':'marR10'">{{stepMessage}}</div>
                              </div>
                            </div>
                          </div>
                    </div>
                </div>
                 <div class="row top-section">
                   <!--  <div class="lg-3">
                        <h4></h4>
                    </div> -->
                   
                  
                </div>            
            </section>
            <div class="app-container top-section marT30">
                <div class="row">
                    <div class="lg-3 projectSetup wiz-pos marT20 padT3" [dir]="textDir">
                         <!-- Steps panle in left start-->
                         <app-ctl-wizard-steps [ctlSteps]=this.wizardSteps [activestep]=currentSteps *ngIf="currentSteps!=5 && !skipAndComplete"></app-ctl-wizard-steps>
                         <!-- Steps panle in left end-->
                    </div>
                    <div class="lg-6 marL20" >
                        <div class="form-wid" >
                            <div *ngIf="currentSteps==1" class="white wid-472 pad30">
                                <app-ctl-gradeclass-form [project_id]="project_id"></app-ctl-gradeclass-form>
                            </div>
                            <div *ngIf="currentSteps==2" class="white wid-800 pad30">
                                <app-ctl-gradesubject-form [refresh]="refreshGradeSubject" [project_id]="project_id" [school_id]="school_id" [inputGradeSubjectListTemp]="gradeSubjectListTemp" (evOpenGradeSubject)="openGradeSubject($event)"></app-ctl-gradesubject-form>
                            </div>
                            <div *ngIf="currentSteps==3" class="white wid-472 pad30">
                                <app-ctl-provision-schooluser [xlsFile]="xlssample?.filename" 
                                [xlsStudentCount]="xlssample?.studentCount" 
                                [xlsTeacherCount]="xlssample?.teacherCount" 
                                [xlsClassCount]="xlssample?.classCount" 
                                [pageType]="'All'" 
                                [school_name]="school_name" 
                                [school_id]="school_id"
                                (uploadDone)="userDetailFileUploaded($event)"
                                (provisionDone)="userDetailProvisioned($event)"></app-ctl-provision-schooluser>
                            </div>
                            <div *ngIf="currentSteps==4" [ngClass]="!setupComplete?'white wid-800 pad30':''">
                               
                                <app-ctl-assign-teacher [mySubjectList]="projectData?.subjects" [refresh]="refreshAssignTeacher" [myTeachers]="teacherList"  [complete]="setupComplete" [assignmentList]="gradeList" [myForm]="fgAssignTeacher" (assignDone)="assignTeacherReady()" (evOpenAssignTeacher)="openAssignTeacher($event)" ></app-ctl-assign-teacher>
                            </div>
                            <div *ngIf="currentSteps==5 && skipAndComplete">
                                
<!--                                 <p>You have now completed the Set Up School process. <br></p>
 -->                                <div class="card setup-school-card marL100">                          
                                    <div class="content text-center">
                                      <div class="school-setup-icon">
                                        <img src="assets/images/proj_mgmt_ico.png" alt="">
                                      </div>                            
                                      <div class="title module-title dashboard-item-title">
                                        {{'School set-up is complete' | translate}}
                                      </div>
                                      <div class="module-desc dashboard-item-subtitle marT5">{{'Your school details can be viewed' | translate}}</div>
                                      <div class="school-setup-button">
                                        <a data-toggle="modal" [routerLink]="['/projectmanagement',this.project_id, this.school_id,'view']" class="btn primary">{{'Go to School Management' | translate}}</a>
                                      </div>
                                      

                                    </div>
                                </div>  


<!--                                 <p><a [routerLink]="['/projectmanagement',this.project_id, this.school_id,'view']"  style="text-decoration: underline;">Go to School Management to view your School.</a></p>
 -->                            </div>
                            <div class="white-bg marB20" *ngIf="currentSteps!=4 && !skipAndComplete" [ngClass]="currentSteps==2?'wid-800':'wid-472'" [style.width]="currentSteps==4?'wid-553':''">
                                <hr>
                                <div class="row spaceBtwn marT20">
                                    <div>
                                        <a class="btn btn-cancel" *ngIf="currentSteps<=3" (click)="cancelSetup()">{{'Cancel' | translate}}</a>
                                    </div>
                                    <div>
                                        
                                        <div *ngIf="nextbtnClicked" style="display:inline;">                          
                                            <div style="display: inline;" [ngClass]="textDir=='rtl'?'marL10':''"><button type="button" (click)='backStep()' *ngIf="(currentSteps > 0 && currentSteps < 5) && (this.gradeList.length==1 || currentGrade==0) || currentSteps==1 || currentSteps==2" class="btn btn-back marR10" ><i class="icon" [ngClass]="textDir=='ltr'?'icon-arrow-left  pull-left marR10':'icon-arrow-right pull-right marL10'"></i>{{'Edit' | translate}}</button></div>
                                            <div *ngIf="nextbtnClicked" style="display:inline;"><button type="button" (click)='nextStep()'  title="Please verify the data samples to continue." [disabled]="!confirmEnable" *ngIf="currentSteps > 0 && currentSteps < 4 && currentSteps!=3" class="btn btn-next primary" >{{'Confirm' | translate}} <i class="icon" [ngClass]="textDir=='ltr'?'icon-arrow-right  pull-right marL10':'icon-arrow-left  pull-left marR10'"></i></button></div>    
                                            <div *ngIf="nextbtnClicked" style="display:inline;"><button type="button" (click)='nextStep()'  title="Please verify the data samples to continue." [disabled]="!confirmEnable" *ngIf="currentSteps == 3" class="btn btn-next primary" >{{'Import' | translate}}</button></div>                            
                        
                                        </div>
                                        <div>
                                            <button type="button" (click)='nextBtnClickFunc()' *ngIf="!nextbtnClicked && currentSteps<4 && currentSteps!=3" class="btn btn-next primary">{{'Next' | translate}} <i class="icon" [ngClass]="textDir=='ltr'?'icon-arrow-right  pull-right marL10':'icon-arrow-left  pull-left marR10'"></i></button>
                                        </div>
                                        <div>
                                            <button type="button" (click)='importUserTeacher()' *ngIf="currentSteps==3 && !nextbtnClicked" [disabled]="!importSuccess" class="btn btn-next primary">{{ 'Verify' | translate}}</button>
                                        </div>
                                </div>
                                </div>
                            </div>
                            
                            
                        </div>
                        <div class="row marT20 marB20">
                            <div *ngIf="currentSteps==3">                                       
                                <label class="info-txt"><i class="icon icon-info font12 padR5"></i><a class="dot-link-txt" (click)="skipStep3and4()">{{'Skip steps 3 & 4' | translate}}</a> {{'if you would prefer to do these tasks later' | translate}}</label>
                             </div>
                             <div *ngIf="currentSteps==4 && !setupComplete">                                       
                                <label class="info-txt"><i class="icon icon-info font12 padR5"></i><a class="dot-link-txt" (click)="skipStep3and4()">{{'Skip step 4' | translate}}</a> {{'if you would prefer to do this task later' | translate}}</label>
                             </div>
                            <div *ngIf="currentSteps<3">
                                <label class="info-txt"><i class="icon icon-info font12 padR5"></i>{{'School details can be edited' | translate}}</label>
                            </div>
                        </div>
                    </div>
                   
                </div>
            </div>
        </div>
    </div>
</main>

<!-- CANCEL MODAL -->
<!-- <div class="dialog" id="cancelModal" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false" aria-labelledby="basicModal" aria-hidden="false" style="display: none; text-align: center">
    <div class="modal-dialog modal-dialog-centered errorModalWidth" role="document" >
        <div class="modal-content">
            <div class="modal-header">    
                <div class="modal-title" id="myModalLabel" style="text-align:left;font-size:18px;color:#4a4a48;vertical-align: top;margin-left: 10px;margin-top: 10px;">
                    <span class="glyphicon confirm" > <img style="height: 26px;width: 26px;margin-top: 0px;" src="assets/images/warning2.png" alt=""></span> &nbsp; {{this.titleMessage}}
                </div>
            </div>
            <div class="modal-body" style="margin-left: 50px;padding-top:0px;padding-bottom: 20px;">
                <div class="modal-text">
                <p class="grey-text" *ngIf="this.detailMessage1" style="line-height:15px;font-size: 12px;text-align: left;color: #808080;" [innerHTML]="detailMessage1"></p>
                
                <p *ngIf="this.detailMessage2" style="font-size: 12px;text-align: left;color: #000000;" [innerHTML]="detailMessage2"></p>
                </div>
            </div>
            <div class="modal-footer" style="height:40px;">
                <p align="center">
                    <a class="btn-sm btn-grey" (click)="cancelModal();">&nbsp;&nbsp;No&nbsp;&nbsp;</a>
                    <a class="btn btn-next" (click)="cancelSetupConfirm()">&nbsp;&nbsp;Yes&nbsp;&nbsp;</a>
                </p>
            </div>
        </div>
    </div>
</div> -->

<!-- assign subjects modal -->
<lib-modalform
    modalClass="assignsubject"
    modalID="assignsubjectModal"
    [viewType]="'add'"
    [modalTitle]="titleModal"
    [btnSaveStatus]="btnStatusSave"
    [btnSaveText]="btnTextAdd"
    [btnCancelText]="btnTextCancel"
    (saveEvent)="saveGradeSubjects()"
    (cancelEvent)="closeModal('subjectsModal')">
    <div class="modalBody">
        <app-ctl-sch-assignsubject-form
            [school_id]="school_id"
            [myGrade]="selectedGrade"           
            [mySelectedSubjectsList]="selectedSubjectList"
            (evBtnSaveStatus)="btnAssignStatus($event)"
            [mySubjectList]="projectData?.subjects">
        </app-ctl-sch-assignsubject-form>
    </div>
</lib-modalform>
<!-- assign subjects modal -->
<!-- Skip modal -->
<!-- <lib-ctl-confirm-modal
  [titleMessage]=this.ctitleMessage
  [subTitleMessage]=this.csubTitleMessage
  [detailMessage]=this.cdetailMessage
  (confirm)="gotoStepComplete()">
</lib-ctl-confirm-modal> -->


<lib-modalform
    modalClass="modalConfirm"
    modalID="skipModal"
    [viewType]="'add'"
    [modalTitle]="titleMessage"
    [btnSaveText]="btnTextAdd"
    [btnCancelText]="btnTextCancel"
    (saveEvent)="gotoStepComplete()"
    (cancelEvent)="skipcancelDelete()">
    <div class="modalBody skipModalWidth">
        <div class="padLR20 padT20 padB5 flexStart">
            <div class="" [ngClass]="textDir=='ltr'?'marR15':'marL15'">
                <img src="assets/images/error3x.png" width=29 height=29 alt="">
            </div>
        <div> 
           <label class="form-title" *ngIf="currentSteps==3">{{'Skip steps 3 & 4?' | translate}}</label>
            <label class="form-title" *ngIf="currentSteps==4">{{'Skip step 4?' | translate}}</label>
        </div>
    </div>

        <div class="pad65 padR20 padB20 dialog-body-txt" [dir]="textDir">
            
            <label  *ngIf="currentSteps==3">{{'Steps 1 & 2 are saved. You will skip the following:' | translate}}<br></label>
            <label  *ngIf="currentSteps==4">{{'Steps 1 - 3 are saved. You will skip this step:' | translate}}<br></label>

            <div class="marT15" >     
                <ul class="skipModalList" [dir]="textDir">
                    <li *ngIf="currentSteps==3">
                        3) {{'Add students & teachers' | translate}}
                    </li>
                    <li *ngIf="currentSteps==3 || currentSteps==4">
                        4) {{'Assign teachers' | translate}}
                    </li>
                </ul>
            </div>  
            <div class="marT15">
            <label  *ngIf="currentSteps==3 ">{{'You can complete these steps in the School Management module.' | translate}}</label>
            <label  *ngIf="currentSteps==4 ">{{'You can complete this step in the School Management module.' | translate}}</label>
        </div>
        </div>
       <!--  <label class="labeltxt" *ngIf="this.detailMessage2" [innerHTML]="detailMessage2"></label> -->
    </div>
</lib-modalform>

<!-- modal window for import data detail -->
<lib-modalform
    modalClass="modalConfirm"
    modalID="cancelImport"
    [viewType]="'add'"
    [modalTitle]="titleMessage"
    [btnSaveText]="btnTextAdd"
    [btnCancelText]="btnTextCancel"
    (saveEvent)="cancelImport(true)"
    (cancelEvent)="cancelImport('')">
    <div class="modalBody">
        <div id="myModalLabel" *ngIf="xlssample?.filename">
            <div class="top-header">
            <label class="form-title" >
                 {{ 'Verify student and teacher data samples' | translate }}
            </label>
            </div>
        
        
        <div class="padLR30 padT20">
            <label class="label-light">{{'Please verify the data summary' | translate}}</label>

            <label class="labeltxt marT20">{{'Student' | translate}} {{'example' | translate}}</label>
            <div class="table-responsive">
                <table *ngIf="xlssample?.filename" class="verify-table table table-border" [dir]="textDir">
                <tr class="labeltxt opac-6">
                    <td *ngFor="let field of xlssample?.studentHeader">{{field}}</td>
                </tr>
                
                <tr class="labeltxt t-body">
                    <td *ngFor="let field of xlssample?.studentHeader">{{xlssample?.studentData[field]}}</td>
                </tr>
                </table>
            </div>
            <p class="grey-text"><strong>{{ 'Teacher' | translate }} {{'example' | translate}}</strong></p>
            <div class="table-responsive">
                <table class="verify-table table table-border" [dir]="textDir">
                <tr class="labeltxt opac-6">
                    <td *ngFor="let field of xlssample?.teacherHeader">{{field}}</td>
                    
                </tr>
                <tr class="labeltxt t-body">
                    <td *ngFor="let field of xlssample?.teacherHeader">{{xlssample?.teacherData[field]}}</td>
                   
                </tr>
                </table>
            </div>
        </div>
    </div>
    </div>
</lib-modalform>
<!-- END modal window for import data detail -->

<!-- Error modal for check and import -->
<lib-modalform
    modalClass="errorModal1"
    modalID="errorModal1"
    [viewType]="'add'"
    [modalTitle]="titleMessage"
    [btnCancelText]="'Ok'"
    (cancelEvent)="cancelImport('')">
    <div class="modalBody errorModalWidth">

        <div class="padLR20  padT20 flexStart">
            <div class="" [ngClass]="textDir=='ltr'?'marR15':'marL15'">
                <img src="assets/images/error3x.png" width=29 height=29 alt="">
            </div>
        <div > 
           <label class="form-title" *ngIf="xlssample?.filename"> {{this.titleMessage}}</label>
           
        </div>
    </div>
        
        <div class="pad65 padR20 padB20 dialog-body-txt" [dir]="textDir">
            <label  *ngIf="this.subTitleMessage"  [innerHTML]="subTitleMessage"></label>
            <label  *ngIf="this.detailMessage1"  [innerHTML]="detailMessage1"></label>
            <label  *ngIf="this.detailMessage2"  [innerHTML]="detailMessage2"></label>
        </div>
    </div>
</lib-modalform>
<!-- END Error modal for check and import -->

<lib-modalform
    modalClass="modalConfirm"
    modalID="cancelModal"
    [viewType]="'add'"
    [modalTitle]="titleMessage"
    [btnSaveText]="btnTextAdd"
    [btnCancelText]="btnTextCancel"
    (saveEvent)="cancelSetupConfirm()"
    (cancelEvent)="cancelModal()">
    <div class="modalBody errorModalWidth">

        <div class="padLR20 padT20 flexStart">
            <div class="" [ngClass]="textDir=='ltr'?'marR15':'marL15'">
                <img src="assets/images/error3x.png" width=29 height=29 alt="">
            </div>
        <div > 
           <label class="form-title" *ngIf="this.titleMessage"> {{this.titleMessage}}</label>
           
        </div>
    </div>
        
        <div class="pad65 padR20 padB20 dialog-body-txt" [dir]="textDir">
            <label  *ngIf="this.subTitleMessage"  [innerHTML]="subTitleMessage"></label>
            
        </div>
    </div>
</lib-modalform>